
import { Injectable } from "@angular/core";
import { ShowMessageService, AuthFactoryService, ErrorInterceptorService} from 'ahm-angular';

@Injectable({
    providedIn: 'root'
  })
  export class AppErrorInterceptorService extends ErrorInterceptorService { 
    
    constructor(_storage: AuthFactoryService, _showMessageService: ShowMessageService) {
        super(_storage, _showMessageService);
    }    

}  